function NpSummernoteDirective() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      config: '=config',
      ngModel: '=ngModel'
    },
    require: '?ngModel',
    template: `<div class="np-summernote">
    <summernote ng-model="ngModel" config="config" on-change="change()"></summernote>
    </div>`,
    link: (scope, element, attrs, ngModelCtrl) => {
      //wrap the summernote directive because it doesn't change ngModelCtrl.$untouched - which we require to use our formHelpersService.getChangedFormValues() with

      scope.change = function () {
        ngModelCtrl.$dirty = true;
      };
    }
  };
}

NpSummernoteDirective.$inject = [];

export default NpSummernoteDirective;



// WEBPACK FOOTER //
// ./src/directives/npSummernote.js